import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const generalApiService = createApi({
  reducerPath: "generalApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getData: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `general/get-data${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
    uploadImage: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `general/upload-image${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    generateUploadUrl: builder.mutation({
      query: ({ filename, filetype, lang }) => ({
        url: `general/generate-upload-url/?filename=${encodeURIComponent(
          filename,
        )}&filetype=${encodeURIComponent(filetype)}&lang=${lang}`,
        method: "GET",
      }),
    }),
    getAnalyticsData: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `general/analytics${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetDataQuery,
  useUploadImageMutation,
  useGenerateUploadUrlMutation,
  useGetAnalyticsDataQuery,
} = generalApiService;
